import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { faqs } from '../data/hotelData';
import Newsletter from '../components/Newsletter/Newsletter';
import './FAQ.css';

function FAQItem({ faq, index }) {
  const [open, setOpen] = useState(false);

  return (
    <motion.div
      className={`faq-item ${open ? 'open' : ''}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.06 }}
    >
      <button className="faq-question" onClick={() => setOpen(!open)}>
        <span>{faq.question}</span>
        <FaChevronDown className="faq-chevron" />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div
            className="faq-answer"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <p>{faq.answer}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default function FAQ() {
  return (
    <main>
      <div className="page-banner">
        <div className="page-banner-content">
          <span className="section-badge">Help Center</span>
          <h1>Frequently Asked Questions</h1>
          <p>Everything you need to know</p>
        </div>
      </div>

      <section className="section faq-page">
        <div className="container">
          <div className="faq-layout">
            <div className="faq-sidebar">
              <h3>Need More Help?</h3>
              <p>Our concierge team is available 24/7 to assist with any questions not covered here.</p>
              <a href="/contact" className="btn btn-primary" style={{ marginTop: '20px', display: 'inline-flex' }}>
                Contact Us
              </a>
            </div>

            <div className="faq-list">
              <div className="section-header" style={{ textAlign: 'left', marginBottom: '32px' }}>
                <span className="section-badge">FAQs</span>
                <h2 className="section-title">Common Questions</h2>
                <div className="gold-line" style={{ margin: '12px 0 0' }} />
              </div>
              {faqs.map((faq, i) => (
                <FAQItem key={i} faq={faq} index={i} />
              ))}
            </div>
          </div>
        </div>
      </section>

      <Newsletter />
    </main>
  );
}
